(function () {
    // TODO: Remove jQuery dependency

    var elements = {
        accordionTrigger: $('[data-accordion-trigger]')
    };

    var events = function () {
        elements.accordionTrigger.on('click', toggleAccordionItem);
    };

    var toggleAccordionItem = function (e) {
        e.preventDefault();

        var selectedTarget = $('.active[data-accordion-target]');
        var accordionItem = $(this).closest('[data-accordion-item]');
        var accordionTarget = accordionItem.next().find('[data-accordion-target]').first();

        var accordionTrigger = $(this).closest('[data-accordion-trigger]');

        $('.order-list__collapse').removeClass('order-list__collapse').addClass('order-list__tmp');
        if (accordionTrigger.hasClass('order-list__expand')) {
          accordionTrigger.removeClass('order-list__expand').addClass('order-list__collapse').removeClass('order-list__tmp');;
        } else {
          accordionTrigger.addClass('order-list__expand').removeClass('order-list__collapse').removeClass('order-list__tmp');;
        }
        $('.order-list__tmp').removeClass('order-list__tmp').addClass('order-list__expand');

        if (accordionTarget.hasClass('active')) {
            accordionTarget.velocity('slideUp', {duration: 300});
            accordionTarget.removeClass('active');
            return;
        }

        if (selectedTarget) {
            selectedTarget.velocity('slideUp', {duration: 300});
            selectedTarget.removeClass('active');
        }

        accordionTarget.velocity('slideDown', {duration: 300, complete:function() {

          delivery.FlickityResize();
          if (accordionTrigger.visible() == false)
          {
              $('html, body').animate({
                  scrollTop: (accordionTrigger.offset().top - 40)
              }, 100);
          }
        }});
        accordionTarget.addClass('active');
    };

    var init = function () {
        events();
    };

    init();
}());
